import React from 'react';
import { ArrowRight } from 'lucide-react';

function CallToAction() {
  return (
    <section className="py-8 sm:py-12 text-center bg-gradient-to-b from-blue-900 to-blue-800 rounded-lg shadow-md mx-2 sm:mx-4 my-4 sm:my-6 mt-50">
      <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-white px-4">
        Ready to revolutionize your React development?
      </h2>
      <p className="mb-4 sm:mb-6 text-base sm:text-lg text-gray-100 px-4">
        Unleash the power of Fleem and create extraordinary React projects today.
      </p>
      <a 
        href="https://www.npmjs.com/package/fleem" 
        className="bg-yellow-500 text-gray-900 px-4 sm:px-6 py-2 rounded-full text-base sm:text-lg font-bold hover:bg-yellow-300 transition-colors duration-200 inline-flex items-center"
      >
        Get Started Now
        <ArrowRight className="ml-2 w-4 h-4" />
      </a>
    </section>
  );
}

export default CallToAction;